<template>
    <div class="index-wrap">
        <div class="firstAboutClass">
            <div class="wordClassFourMain">关&nbsp;于&nbsp;我&nbsp;们</div>
            <div class="wordClassFourMainChild">中国青少年运动健康领先品牌</div>
        </div>
        <div>
            <div style="background: #F5F5F5;width: 100%;height: 150px;position: relative">
                <div class="wordClassChildFour">满分价值观</div>
                <div class="wordClassChildLineFour"></div>
            </div>
            <div style="background: #F5F5F5;position: relative;height: 680px">
                <div style="height: 680px;width: 64%;position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);">
                    <div style="height: 231px;width: 100%;position: relative;border-bottom: 1px solid #CFCFCF;">
                        <div style="position: absolute;top:49%;transform: translateY(-50%);font-family: Source Han Sans CN;font-weight: bold;color: #222222;line-height: 61px;font-size: 32px;">
                            满分使命
                        </div>
                        <div style="position: absolute;top:49%;white-space:nowrap;margin-left:30%;transform: translateY(-50%);font-family: Source Han Sans CN;font-weight: 500;color: #222222;line-height: 61px;font-size: 32px;">
                            让中国不再有近视、肥胖、抑郁的青少年
                        </div>
                        <div class="wordClassChildLineFourSml"></div>
                    </div>
                    <div style="height: 231px;width: 100%;border-bottom: 1px solid #CFCFCF;">
                        <div style="height: 231px;width: 100%;position: relative;">
                            <div style="position: absolute;top:49%;transform: translateY(-50%);font-family: Source Han Sans CN;font-weight: bold;color: #222222;line-height: 61px;font-size: 32px;">
                                满分目标
                            </div>
                            <div style="position: absolute;top:39%;white-space:nowrap;margin-left:30%;transform: translateY(-50%);font-family: Source Han Sans CN;font-weight: 500;color: #222222;line-height: 61px;font-size: 32px;">
                                切实提升中国青少年身体素质与运动水平
                            </div>
                            <div style="position: absolute;top:66%;white-space:nowrap;margin-left:30%;transform: translateY(-50%);font-family: Source Han Sans CN;font-weight: 500;color: #222222;line-height: 61px;font-size: 32px;">
                                切实提升中国体育教育从业者基础素质与社会地位
                            </div>
                            <div class="wordClassChildLineFourSml"></div>
                        </div>
                    </div>
                    <div style="height: 231px;width: 100%">
                        <div style="height: 231px;width: 100%;position: relative;">
                            <div style="position: absolute;top:49%;transform: translateY(-50%);font-family: Source Han Sans CN;font-weight: bold;color: #222222;line-height: 61px;font-size: 32px;">
                                满分价值主张
                            </div>
                            <div style="position: absolute;top:49%;white-space:nowrap;margin-left:30%;transform: translateY(-50%);font-family: Source Han Sans CN;font-weight: 500;color: #222222;line-height: 61px;font-size: 32px;">
                                让校长更省心 · 让老师更用心 · 让学生更开心 · 让家长更放心
                            </div>
                            <div class="wordClassChildLineFourSml"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="background: #F5F5F5;width: 100%;height: 150px;position: relative">
                <div class="wordClassChildFour">招贤纳士</div>
                <div class="wordClassChildLineFour"></div>
            </div>

            <div><!--运动科技研发专家-->
                <div style="position: relative;width: 100%;height: 475px;background: #F5F5F5">
                    <div style="height: 433px;width: 1400px;position: absolute;background: #FFFFFF ;box-shadow: 0px 0px 38px 2px rgba(34,34,34,0.15);border-radius: 10px;left: 50%;top: 50%;transform: translate(-50%, -50%);">
                        <div style="width: 600px;height: 433px;">
                            <img style="position: absolute;background-size: 100% 100%;height: 432px;"
                                 src="../assets/pageFour/recruitOne.png">
                            <div style="position: absolute;bottom: 122px;left:206px;width: 100%;text-align: left;font-size: 36px;font-weight: bold;font-family: Source Han Sans CN;color: #FFFFFF;letter-spacing:2px">
                                运动科技研发专家
                            </div>
                        </div>
                        <div style="position: absolute;width: 640px;height:433px;left: 74.5%;top: 54%;transform: translate(-50%, -50%);">
                            <br>
                            <br>
                            <span style="font-size: 24px;font-family: Source Han Sans CN;font-weight: bold;color: #4C4C4C;line-height: 24px;">岗位职责：<br></span>
                            <br>
                            <span style="font-size: 16px;font-family: Source Han Sans CN;font-weight: 400;color: #8D8D8D;line-height: 36px;white-space: nowrap">
                          1. 负责运动科技产品的研发工作，包括产品设计、原型制作、测试与优化等；<br>
                          2. 跟踪行业动态，分析竞品，关注新技术、新材料的应用，提出创新性的产品设计方案；<br>
                          3. 与设计、工程、市场等部门紧密合作，确保产品研发的顺利进行；<br>
                          4. 负责撰写技术文档，包括产品说明书、技术规格书等；<br>
                        </span>
                            <br>
                            <span style="font-size: 24px;font-family: Source Han Sans CN;font-weight: bold;color: #4C4C4C;line-height: 24px;">任职要求：<br></span>
                            <br>
                            <span style="font-size: 16px;font-family: Source Han Sans CN;font-weight: 400;color: #8D8D8D;line-height: 36px;white-space: nowrap">
                         1. 985或211院校硕士及以上学历，运动科学、体育工程、机械工程、材料科学等相关专业优先；<br>
                         2. 5年以上运动科技产品研发经验，具有丰富的产品设计、原型制作、测试与优化经验；<br>
                         3. 具备较强的创新能力，能够独立完成产品方案设计、原型制作等工作；<br>
                        </span>
                        </div>
                    </div>
                </div>
            </div>
            <div style="height: 20px;background: #F5F5F5"></div>
            <div><!--体育教育教学创新专家-->
                <div style="position: relative;width: 100%;height: 475px;background: #F5F5F5">
                    <div style="height: 433px;width: 1400px;position: absolute;background:#FFFFFF;box-shadow: 0px 0px 38px 2px rgba(34,34,34,0.15);border-radius: 10px;left: 50%;top: 50%;transform: translate(-50%, -50%);">

                        <div style="position: absolute;width: 640px;height:433px;left: 25%;top: 54%;transform: translate(-50%, -50%);">
                            <br>
                            <br>
                            <span style="font-size: 24px;font-family: Source Han Sans CN;font-weight: bold;color: #4C4C4C;line-height: 24px;">岗位职责：<br></span>
                            <br>
                            <span style="font-size: 16px;font-family: Source Han Sans CN;font-weight: 400;color: #8D8D8D;line-height: 36px;white-space: nowrap">
                      1. 负责体育教育教学方案的设计和实施，包括课程设置、教学方法、评价体系等；<br>
                      2. 与教学、研发等部门紧密合作，确保教学方案的顺利进行；<br>
                      3. 负责撰写教学文档，包括教学大纲、教案、教材等；<br>
                      4. 负责对内对外课程展示、教学交流、教研成果汇报等工作；<br>
                        </span>
                            <br>
                            <span style="font-size: 24px;font-family: Source Han Sans CN;font-weight: bold;color: #4C4C4C;line-height: 24px;">任职要求：<br></span>
                            <br>
                            <span style="font-size: 16px;font-family: Source Han Sans CN;font-weight: 400;color: #8D8D8D;line-height: 36px;white-space: nowrap">
                      1. 国内知名体育类、师范类院校本科及以上学历，体育教育、教育学等相关专业优先；<br>
                      2. 3年以上体育教育教学经验，具有丰富的教学设计、实施、评价经验；<br>
                      3. 熟悉体育教育课程标准，能够独立完成教学方案设计、实施等工作；<br>
                        </span>
                        </div>
                        <div style="position: absolute;width: 600px;height: 433px;left: 71.5%;top: 50%;transform: translate(-50%, -50%);">
                            <img style="background-size: 100% 100%;height: 432px;"
                                 src="../assets/pageFour/recruitTwo.png">
                            <div style="position: absolute;bottom: 122px;left:165px;width: 100%;text-align: left;font-size: 36px;font-weight: bold;font-family: Source Han Sans CN;color: #FFFFFF;letter-spacing:2px">
                                体育教育教学创新专家
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="height: 20px;background: #F5F5F5"></div>
            <div><!--校园市场营销拓展专家-->
                <div style="position: relative;width: 100%;height: 475px;background: #F5F5F5">
                    <div style="height: 433px;width: 1400px;position: absolute;background: #FFFFFF ;box-shadow: 0px 0px 38px 2px rgba(34,34,34,0.15);border-radius: 10px;left: 50%;top: 50%;transform: translate(-50%, -50%);">
                        <div style="width: 600px;height: 433px;">
                            <img style="position: absolute;background-size: 100% 100%;height: 432px;"
                                 src="../assets/pageFour/recruitThree.png">
                            <div style="position: absolute;bottom: 122px;left:161px;width: 100%;text-align: left;font-size: 36px;font-weight: bold;font-family: Source Han Sans CN;color: #FFFFFF;letter-spacing:2px">
                                校园市场营销拓展专家
                            </div>
                        </div>
                        <div style="position: absolute;width: 640px;height:433px;left: 74.5%;top: 54%;transform: translate(-50%, -50%);">
                            <br>
                            <br>
                            <span style="font-size: 24px;font-family: Source Han Sans CN;font-weight: bold;color: #4C4C4C;line-height: 24px;">岗位职责：<br></span>
                            <br>
                            <span style="font-size: 16px;font-family: Source Han Sans CN;font-weight: 400;color: #8D8D8D;line-height: 36px;white-space: nowrap">
                          1. 负责公司在校园市场的营销策划与执行，包括市场调研、竞品分析、活动策划等；<br>
                          2. 深入了解校园市场特点，制定针对性的营销策略，提高公司在校园市场的知名度和影响力；<br>
                          3. 跟踪行业动态，关注新技术、新材料的应用，为营销创新提供支持；<br>
                          4. 负责撰写营销报告，包括市场分析报告、活动总结报告等；<br>
                        </span>
                            <br>
                            <span style="font-size: 24px;font-family: Source Han Sans CN;font-weight: bold;color: #4C4C4C;line-height: 24px;">任职要求：<br></span>
                            <br>
                            <span style="font-size: 16px;font-family: Source Han Sans CN;font-weight: 400;color: #8D8D8D;line-height: 36px;white-space: nowrap">
                          1. 985或211院校硕士及以上学历，市场营销、广告传媒、企业管理等相关专业优先；<br>
                          2. 5年以上校园市场营销经验，熟悉校园市场特点，具有丰富的市场调研、竞品分析经验；<br>
                          3. 具备较强的创新能力，能够独立完成营销策划、活动执行等工作；<br>
                        </span>
                        </div>
                    </div>
                </div>
            </div>
            <div style="height: 80px;background: #F5F5F5"></div>
            <div style="height: 433px;position: relative;background:#F5F5F5;">
                <div style="height: 433px;width: 1400px;position: absolute;background:#F5F5F5;left: 50%;top: 50%;transform: translate(-50%, -50%);">
                    <img style="position: absolute;background-size: 100% 100%;height: 432px;"
                         src="../assets/pageFour/contactImg.png">
                    <div style="text-align: center;position: absolute;font-size: 24px;font-family: Source Han Sans CN;font-weight: bold;color: #FFFFFF;line-height: 24px;left: 50%;top: 14%;transform: translate(-50%, -50%);">
                        我们为您提供：
                    </div>
                    <div style="text-align: center;position: absolute;font-size: 16px;font-family: Source Han Sans CN;font-weight: bold;color: #FFFFFF;line-height: 24px;left: 50%;top: 83%;transform: translate(-50%, -50%);width: 888px">
                        如果您热爱体教创新领域，渴望在这个领域发挥自己的才能，欢迎加入我们，共同为推动中国体育教育的发展贡献力量!
                    </div>
                    <div style="text-align: center;position: absolute;font-size: 16px;font-family: Source Han Sans CN;font-weight: bold;color: #FFFFFF;line-height: 24px;left: 50%;top: 91%;transform: translate(-50%, -50%);width: 888px">
                        请将您的简历发送至: <span style="color:#FFD900 ">muffinhr@163.com</span></div>
                </div>
            </div>
            <div style="height: 40px;background: #F5F5F5"></div>
        </div>
    </div>
</template>

<script>

    export default {
        mounted() {
        },
        data() {
            return {}
        }
    }
</script>

<style scoped>

    .firstAboutClass {
        position: relative;
        width: 100%;
        height: 625px;
        min-width: 500px;
        background-image: url('../assets/pageFour/mainBack.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .wordClassFourMain {
        position: absolute; /* 设置绝对定位子元素 */
        top: 226px; /* 将子元素底部与父元素底部对齐 */
        width: 100%; /* 设置子元素宽度为父元素宽度 */
        text-align: center; /* 设置子元素文本居中 */
        font-size: 78px;
        font-weight: 800;
        /*font-family: Source Han Sans CN;*/
        font-family: 'heavy';
        color: #222222;
    }

    .wordClassFourMainChild {
        position: absolute; /* 设置绝对定位子元素 */
        top: 360px; /* 将子元素底部与父元素底部对齐 */
        width: 100%; /* 设置子元素宽度为父元素宽度 */
        text-align: center; /* 设置子元素文本居中 */
        font-size: 37px;
        font-weight: 400;
        /*font-family: Source Han Sans CN;*/
        font-family: 'heavy';
        color: #222222;
    }

    .wordClassChildFour {
        position: absolute; /* 设置绝对定位子元素 */
        top: 26px; /* 将子元素底部与父元素底部对齐 */
        width: 100%; /* 设置子元素宽度为父元素宽度 */
        text-align: center; /* 设置子元素文本居中 */
        font-size: 48px;
        font-weight: 800;
        /*font-family: Source Han Sans CN;*/
        font-family: 'heavy';
        color: #222222;
    }

    .wordClassChildLineFour {
        position: absolute; /* 设置绝对定位子元素 */
        bottom: 30px; /* 将子元素底部与父元素底部对齐 */
        height: 4px;
        width: 79px;
        transform: translate(-50%, -50%);
        left: 50%;
        background: #F8DB00;
    }

    .wordClassChildLineFourSml {
        position: absolute; /* 设置绝对定位子元素 */
        bottom: 80px; /* 将子元素底部与父元素底部对齐 */
        height: 5px;
        width: 85px;
        background: #F8DB00;
    }

    .homeClassThree {
        background-image: url('../assets/pageOne/homeBackThree.png');
        background-size: 100% 100%;
    }

</style>

<style>
    .index-wrap {
        width: 100%;
        height: auto;
        overflow: hidden;
        position: relative;
    }

    .index-left-block h2 {
        background: #4fc08d;
        color: #fff;
        padding: 10px 15px;
        margin-bottom: 20px;
    }

    .index-left-block h3 {
        padding: 0 15px 5px 15px;
        font-weight: bold;
        color: #222;
    }

    .index-left-block ul {
        padding: 10px 15px;
    }

    .index-left-block li {
        padding: 5px;
    }

    .index-board-item h2 {
        font-size: 18px;
        font-weight: bold;
        color: #000;
        margin-bottom: 15px;
    }

    .VueCarousel-slide img {
        width: 100%;
    }

</style>



// WEBPACK FOOTER //
// src/pages/about.vue